import { SupplierOverlay } from '#app/routes/mocra+/_form+/components/suppliers/overlay.tsx'
import { type SupplierDraft } from '#app/routes/mocra+/_form+/components/suppliers/types.ts'

type Props = {
	readonly open: boolean
	readonly onOpenChange: (open: boolean) => void
	readonly onSubmit: (draft: SupplierDraft) => void
	readonly initialValue: SupplierDraft
	readonly onClosed?: () => void
	readonly onCancel?: () => void
}

export function SupplierEditOverlay({
	open,
	onOpenChange,
	onSubmit,
	initialValue,
	onClosed,
	onCancel,
}: Props) {
	return (
		<SupplierOverlay
			mode="edit"
			open={open}
			onOpenChange={onOpenChange}
			onSubmit={onSubmit}
			initialValue={initialValue}
			onClosed={onClosed}
			onCancel={onCancel}
		/>
	)
}
